import getPageLocalesData from '@src/global-locales/get-page-locales-data';
import toWebpImage from '@src/utils/to-webp-image.js';
const pageLocalesData = getPageLocalesData();
const textInfo = pageLocalesData.main.fourSection;

export default {
  // 地图名称
  mapName: {
    mapName1: textInfo.mapName.mapName1,
    mapName2: textInfo.mapName.mapName2,
    mapName3: textInfo.mapName.mapName3,
    mapName4: textInfo.mapName.mapName4,
    mapName5: textInfo.mapName.mapName5
  },
  // 地图详情内容
  mapContentList: {
    // 大火山口 VolcanicCrater
    VolcanicCrater: [
      {
        name: '卡利斯提火山',
        content: '占位',
        englishTitle: 'Kalista Volcanic Crater',
        content_img: toWebpImage(require('./images/VolcanicCrater/detail-content-img-1.jpg')),
        ...textInfo.mapContentList.VolcanicCrater[0]
      },
      {
        name: '火山口内部',
        content: '占位',
        englishTitle: 'Volcanic Crater Interior',
        content_img: toWebpImage(require('./images/VolcanicCrater/detail-content-img-2.jpg')),
        ...textInfo.mapContentList.VolcanicCrater[1]
      },
      {
        name: '南伍德镇',
        content: '占位',
        englishTitle: 'South Wood',
        content_img: toWebpImage(require('./images/VolcanicCrater/detail-content-img-3.jpg')),
        ...textInfo.mapContentList.VolcanicCrater[2]
      },
      {
        type: 'unknown',
        name: textInfo.unknownTxet
      }
    ],
    // 海积平原 MarinePlain
    MarinePlain: [
      {
        name: '跳板岛',
        content: '占位',
        englishTitle: 'Leapstone Island',
        content_img: toWebpImage(require('./images/MarinePlain/detail-content-img-1.jpg')),
        ...textInfo.mapContentList.MarinePlain[0]
      },
      // {
      //   name: '北伍德镇',
      //   content: '占位',
      //   englishTitle: 'North Wood',
      //   content_img: toWebpImage(require('./images/MarinePlain/detail-content-img-2.jpg')),
      //   ...textInfo.mapContentList.MarinePlain[1]
      // }
      {
        type: 'unknown',
        name: textInfo.unknownTxet
      }
    ],
    // 山丘台地 Plateau
    Plateau: [
      {
        name: '芯石提炼所',
        content: '占位',
        englishTitle: 'Corite Refinery',
        content_img: toWebpImage(require('./images/Plateau/detail-content-img-1.jpg')),
        ...textInfo.mapContentList.Plateau[0]
      },
      {
        name: '日出海岸',
        content: '占位',
        englishTitle: 'Sunrise Coast',
        content_img: toWebpImage(require('./images/Plateau/detail-content-img-2.jpg')),
        ...textInfo.mapContentList.Plateau[1]
      },
      {
        type: 'unknown',
        name: textInfo.unknownTxet
      }
    ],
    // 堰塞湖区 BarrierLake
    BarrierLake: [
      {
        name: '电站水坝',
        content: '占位',
        englishTitle: 'Hydropower Dam',
        content_img: toWebpImage(require('./images/BarrierLake/detail-content-img-1.jpg')),
        ...textInfo.mapContentList.BarrierLake[0]
      },
      {
        type: 'unknown',
        name: textInfo.unknownTxet
      }
    ],
    // 隆升荒原 BarrenUpland
    BarrenUpland: [
      {
        name: '撞击区',
        content: '占位',
        englishTitle: 'Impact Zone',
        content_img: toWebpImage(require('./images/BarrenUpland/detail-content-img-1.jpg')),
        ...textInfo.mapContentList.BarrenUpland[0]
      },
      {
        name: '崖侧矿井',
        content: '占位',
        englishTitle: 'Cliffside Mines',
        content_img: toWebpImage(require('./images/BarrenUpland/detail-content-img-2.jpg')),
        ...textInfo.mapContentList.BarrenUpland[1]
      },
      {
        name: '太阳岩',
        content: '占位',
        englishTitle: 'Sunstone',
        content_img: toWebpImage(require('./images/BarrenUpland/detail-content-img-3.jpg')),
        ...textInfo.mapContentList.BarrenUpland[2]
      },
      {
        type: 'unknown',
        name: textInfo.unknownTxet
      }
    ]
  }
};
